import * as React from "react";
import { forwardRef } from "react";
const SvgIconLogout = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 16, viewBox: "0 0 18 16", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.3334 8L13.1667 3.83333L12.0001 5L14.1667 7.16667H5.66675V8.83333H14.1667L12.0001 11L13.1667 12.1667L17.3334 8ZM2.33341 2.16667H9.00008V0.5H2.33341C1.41675 0.5 0.666748 1.25 0.666748 2.16667V13.8333C0.666748 14.75 1.41675 15.5 2.33341 15.5H9.00008V13.8333H2.33341V2.16667Z", fill: "#002244" }));
const ForwardRef = forwardRef(SvgIconLogout);
export default ForwardRef;
